import { createSlice } from '@reduxjs/toolkit'
import { createSelector } from 'reselect'
import { apiCallBegan } from './api'
//import moment from "moment";

const slice = createSlice({
  name: 'appointment',
  initialState: {
    appointment: [],
    pagination: {},
    getFeedback: {},
    refund: {},
    loading: false,
    lastFetch: null,
  },
  reducers: {
    appointmentRequested: (appointment, action) => {
      appointment.loading = true
    },

    appointmentReceived: (appointment, action) => {
      appointment.appointment = action.payload.data
      appointment.pagination = action.payload.pagination
      appointment.loading = false
      appointment.lastFetch = Date.now()
    },

    appointmentRequestFailed: (appointment, action) => {
      appointment.loading = false
    },
    appointmentRefund: (appointment, action) => {
      appointment.refund = action.payload.data
      appointment.loading = false
      appointment.lastFetch = Date.now()
    },

    appointmentRefundRequestFailed: (appointment, action) => {
      appointment.loading = false
    },

    getFeedbackReceived: (appointment, action) => {
      // console.log("into getfeedback  --- > ", action.payload)
      appointment.getFeedback = action.payload
    },
  },
})

export const {
  appointmentRequested,
  appointmentReceived,
  appointmentRequestFailed,
  appointmentRefund,
  appointmentRefundRequestFailed,
  getFeedbackReceived,
} = slice.actions
export default slice.reducer

// Action Creators
const url = 'appointment/list'
const url1 = 'appointment/refund/'
const url2 = 'appointment/createComment'
const url3 = 'wati/sendReminder'
const url4 = 'appointment/paid/'
const url5 = 'appointment/calcelByAdmin/'
const url6 = 'appointment/addAppointmentCount'
const url7 = 'appointment/generateReport'
const url8 = 'appointment/feedback'
const url9 = 'appointment/AuditReport'
const url10 = 'appointment/onlinePaid/'

export const loadAllAppointment = params => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url,
      params,
      onStart: appointmentRequested.type,
      onSuccess: appointmentReceived.type,
      onError: appointmentRequestFailed.type,
    })
  )
}
export const addComment = (data, callback) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url: url2,
      method: 'POST',
      data,
      callback,
      onSuccess: appointmentRequestFailed.type,
      onError: appointmentRequestFailed.type,
    })
  )
}
export const generateReport = (data, callback) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url: url7,
      method: 'POST',
      data,
      responseType: "blob",
      callback,
      // onSuccess: appointmentRequestFailed.type,
      // onError: appointmentRequestFailed.type,
    })
  )
}
export const AuditReport = (data, callback) => (dispatch, getState) => {
  return dispatch(
    apiCallBegan({
      url: url9,
      method: 'POST',
      data,
      responseType: "blob",
      callback,
      // onSuccess: appointmentRequestFailed.type,
      // onError: appointmentRequestFailed.type,
    })
  )
}
export const appointmentAllRefund = (id, data, callback) => dispatch => {
  return dispatch(
    apiCallBegan({
      url: url1 + id,
      method: 'POST',
      data,
      callback,
      onSuccess: appointmentRefund.type,
      onError: appointmentRefundRequestFailed.type,
    })
  )
}
export const appointmentCancel = (id, callback) => dispatch => {
  return dispatch(
    apiCallBegan({
      url: url5 + id,
      method: 'DELETE',
      callback,
    })
  )
}
export const paymentReminder = (id) => dispatch => {
  return dispatch(
    apiCallBegan({
      url: url3,
      method: 'POST',
      data: {appointmentId: id},
      // callback,
      // onSuccess: appointmentRefund.type,
      // onError: appointmentRefundRequestFailed.type,
    })
  )
}

export const paidStatus = (id, data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: url4  + id,
      method: "PUT",
      data,
      callback,
      // onSuccess: updatedPatient.type,
      // onError: updatedPatientRequestFailed.type,
    })
  );
};
export const handleOnlinePaid = (id, data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: url10  + id,
      method: "PUT",
      data,
      callback,
      // onSuccess: updatedPatient.type,
      // onError: updatedPatientRequestFailed.type,
    })
  );
};

export const addAppointmentCount = (callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: url6,
      method: "POST",
      callback,
    })
  );
};

export const saveFeedback = (id, data, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: "feedback/add/" + id,
      method: "POST",
      data,
      callback,
    })
  );
};

export const loadFeedback = (id, callback) => (dispatch) => {
  return dispatch(
    apiCallBegan({
      url: "feedback/appointment/" + id,
      callback,
      onSuccess: getFeedbackReceived.type,
    })
  );
};

export const getAppointment = createSelector(
  state => state.entities.appointment,
  appointment => appointment
)
